import { useDependencies } from '@servicetitan/react-ioc';
import { FinancingApi, LoanApplicationRead } from '@servicetitan/financing-api-client';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useLoansWithNoJob = (
    tenantId: string,
    customerId: string,
    buId: string,
    providerName?: string,
) => {
    const [apiClient] = useDependencies(FinancingApi);
    return useQuery({
        queryKey: ['loansWithNoJob', tenantId, customerId, buId, providerName],
        enabled: !!tenantId && !!customerId && !!buId,
        queryFn: async (): Promise<AxiosResponse<LoanApplicationRead[]>> => {
            try {
                return await apiClient.loansGetLoansWithNoJob({
                    tenantId,
                    customerId,
                    buId,
                    providerName,
                });
            } catch {
                // Treat any error (404, 502, connection errors, etc.) as an empty list.
                // Errors here should not result in an error screen.
                return { data: [] } as unknown as AxiosResponse<LoanApplicationRead[]>;
            }
        },
    });
};
